import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { WholesaleAppFragmentDoc } from '../../fragments/__generated__/WholesaleApp.generated';
import { ErrorFragmentDoc } from '../../fragments/__generated__/Error.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholesaleAppCreateMutationVariables = Types.Exact<{
  wholesaleAppInput: Types.WholesaleAppInput;
}>;


export type WholesaleAppCreateMutation = { wholesaleAppCreate: { wholesaleApp: { id: string, pk: number, created: any, email: string, storeName: string, storeType: Types.StoreTypeEnum, storeYear: number | null, websiteUrl: string | null, instagramUrl: string | null, facebookUrl: string | null, brands: Array<string>, storeDescription: Array<string>, status: Types.WholesaleAppStatusEnum, initialAddress: { firstName: string | null, lastName: string | null, country: Types.CountryCodeEnum | null, city: string | null } | null } | null, errors: Array<{ field: string, messages: Array<string> }> } };


export const WholesaleAppCreateDocument = gql`
    mutation WholesaleAppCreate($wholesaleAppInput: WholesaleAppInput!) {
  wholesaleAppCreate(wholesaleAppInput: $wholesaleAppInput) {
    wholesaleApp {
      ...WholesaleAppFragment
    }
    errors {
      ...Error
    }
  }
}
    ${WholesaleAppFragmentDoc}
${ErrorFragmentDoc}`;
export type WholesaleAppCreateMutationFn = Apollo.MutationFunction<WholesaleAppCreateMutation, WholesaleAppCreateMutationVariables>;

/**
 * __useWholesaleAppCreateMutation__
 *
 * To run a mutation, you first call `useWholesaleAppCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWholesaleAppCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wholesaleAppCreateMutation, { data, loading, error }] = useWholesaleAppCreateMutation({
 *   variables: {
 *      wholesaleAppInput: // value for 'wholesaleAppInput'
 *   },
 * });
 */
export function useWholesaleAppCreateMutation(baseOptions?: Apollo.MutationHookOptions<WholesaleAppCreateMutation, WholesaleAppCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WholesaleAppCreateMutation, WholesaleAppCreateMutationVariables>(WholesaleAppCreateDocument, options);
      }
export type WholesaleAppCreateMutationHookResult = ReturnType<typeof useWholesaleAppCreateMutation>;
export type WholesaleAppCreateMutationResult = Apollo.MutationResult<WholesaleAppCreateMutation>;
export type WholesaleAppCreateMutationOptions = Apollo.BaseMutationOptions<WholesaleAppCreateMutation, WholesaleAppCreateMutationVariables>;